import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onBrowserHistoryHeadingClicked = ({
	attributes,
	nonPrivacySafeAttributes,
}: {
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	eventType: 'ui',
	action: 'clicked',
	actionSubject: 'browserHistoryHeading',
	attributes,
	nonPrivacySafeAttributes,
});
